import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: `${theme.spacing(2.5)}px ${theme.spacing(3)}px`,
    width: '100%',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF'
  },
  filters: {
    display: 'flex',
    alignItems: 'center',
    flexBasis: 'auto',
    justifyContent: 'space-between',
    margin: `${theme.spacing(1)}px 0px ${theme.spacing(2)}px 0px`
  },
  tableRow: {
    height: 50,
    '& > td': {
      fontFamily: 'National',
      fontSize: 15,
      letterSpacing: 0,
      lineHeight: '21px',
      border: 0,
      padding: `${theme.spacing(0.8)}px ${theme.spacing(1.5)}px ${theme.spacing(0.8)}px 0px`
    },
    '& > td:first-child': {
      paddingLeft: theme.spacing(1)
    }
  },
  headerRow: {
    height: 50,
    backgroundColor: '#F2F4F9',
    '& > th': {
      fontSize: '10px',
      fontWeight: 'bold',
      letterSpacing: '2px',
      lineHeight: '13px',
      border: 0,
      padding: `${theme.spacing(0.8)}px ${theme.spacing(1.5)}px ${theme.spacing(0.8)}px 0px`,
      textTransform: 'uppercase'
    },
    '& > th:first-child': {
      paddingLeft: theme.spacing(1)
    }
  },
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    borderTop: '1px solid black'
  },
  button: {
    backgroundColor: '#E4E8F1',
    width: '120px',
    height: '40px',
    letterSpacing: '2px',
    marginLeft: 40
  },
  nonDefault: {
    marginRight: theme.spacing(2.5),
    '& > div': {
      border: '1px solid #F7901E'
    },
    '& > div:focus': {
      border: '1px solid #F7901E'
    }
  },
  dropdownSelect: {
    marginRight: theme.spacing(2.5)
  },
  inputContainer: {
    transition: 'border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    borderRadius: '20px',
    border: '1px solid #E4E8F1',
    padding: '4px 8px',
    '& > div > input': {
      fontSize: 14,
      fontFamily: 'National'
    }
  },
  menuItem: {
    fontFamily: 'National',
    fontSize: 16
  },
  rightFilters: {
    display: 'flex'
  }
}))
